import React from "react";
import Logo from "@assets/logos/logo.svg";
import { useMediaQuery } from "react-responsive";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { Pagination, Autoplay } from "swiper/modules";

import styles from "./SignUpCarouselDesktop.module.css";

import Image1 from "@assets/carousel/login-1.png";
import Image2 from "@assets/carousel/login-2.png";
import Image3 from "@assets/carousel/login-3.png";
import Image4 from "@assets/carousel/login-4.png";
import Image5 from "@assets/carousel/login-5.png";

const SignUpCarouselDesktop = () => {
  const images = [Image1, Image2, Image3, Image4, Image5];

  return (
    <div className="">
      {/* Carousel Section */}
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={2}
        centeredSlides={true}
        loop={true}
        speed={800}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} ${
              className.includes("swiper-pagination-bullet-active")
                ? styles.activeBullet
                : styles.inactiveBullet
            } rounded-full mx-1"></span>`;
          },
        }}
        className={styles.mySwiper}>
        {images.map((img, idx) => (
          <SwiperSlide key={idx}>
            <div className={`${styles.imageContainer}`}>
              <img
                src={img}
                alt={`Slide ${idx + 1}`}
                className={`object-cover rounded-lg ${styles.image}`}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <p className="font-semibold text-[30px] text-center mt-12 text-[#2031AE]">
        TYLT THE WAY YOU PAY!
      </p>
    </div>
  );
};

export default SignUpCarouselDesktop;
